// extracted by mini-css-extract-plugin
export default {"body":"ItemContainer_body__4aNKD","gridContainer":"ItemContainer_gridContainer__nErYn","flexContainer":"ItemContainer_flexContainer__LcrK6"};